import React from 'react';
import Handler from './Handler';
import styles from '../../../styles/sessions.scss';

const SessionsDay = React.createClass({
  displayName: 'Day',

  getInitialState: function () {
    return {
      timeFrom: TIME_DAY * this.props.day,
      width: 0,

    };
  },

  getDefaultProps: function () {
    return {
      disabled: false,
      name: '',
      value: '',
      editable: false,
    };
  },

  componentDidMount: function () {
    let container = this.refs.SessionsContainer,
      clientRect = container.getClientRects()[0];
    this.setState({
      width: clientRect.width,
      left: clientRect.left,
    });
  },

  onDeleteTrades(index) {
    this.props.onDelete('Trades', index);
  },
  onDeleteQuotes(index, name) {
    this.props.onDelete('Quotes', index);
  },

  onChangeTrades: function (index, name, value) {
    this.props.onChange('Trades', index, name, value);
  },

  onChangeQuotes: function (index, name, value) {
    this.props.onChange('Quotes', index, name, value);
  },

  onEditStartTrades: function (index, name) {
    this.props.onEditStart('Trades', index, name);

  },

  onEditStartQuotes: function (index, name) {
    this.props.onEditStart('Quotes', index, name);
  },
  onEditStop: function () {
    this.props.onEditStop();
  },

  timeToSeconds: function (time) {
    time = time.split(':');
    if (time.length !== 2) return;
    let hour = Math.abs(parseInt(time[0]));
    let minutes = Math.abs(parseInt(time[1]));
    if (hour > 24 || minutes > 60) {
      return null;
    }
    return hour * TIME_HOUR + minutes * TIME_MIN;
  },
  pad: function (v) {
    return (v < 10 ? '0' : '') + v;
  },

  secondsToTime: function (seconds) {
    return this.pad(parseInt(seconds / TIME_HOUR));
  },

  addSessionQuotes: function (e) {
    this.addSession('Quotes', e);
  },

  addSessionTrades: function (e) {
    this.addSession('Trades', e);
  },

  addSession: function (type, e) {
    let position = e.pageX,
      left = this.state.left,
      width = this.state.width,
      x = (position - left),
      value = Math.round(x / width * TIME_DAY) + this.state.timeFrom;

    this.props.onAddSession(type, value);
  },

  render: function () {
    let divisions = [];

    for (let i = 1; i <= 23; i++) {
      let left = (100 / 24 * i).toFixed(2);
      divisions.push(<div key={i} className={styles["sessions-division"]} style={{left: left + "%"}}><span></span>
      </div>);
    }

    let handlers = [];

    for (let i = 0; i < this.props.values.length; i++) {
      let item = this.props.values[i];
      if (item.From >= this.state.timeFrom && item.To <= this.state.timeFrom + TIME_DAY && item.Type !== Constants.Diff) {
        handlers.push(<Handler type={this.props.type}
                               editable={this.props.editable}
                               index={i}
                               key={'from-' + i}
                               from={item.From}
                               to={item.To}
                               containerWidth={this.state.width}
                               containerLeft={this.state.left}
                               timeFrom={this.state.timeFrom}
                               editing={this.props.editing.Quotes}
                               onDelete={this.onDeleteQuotes}
                               onChange={this.onChangeQuotes}
                               onEditStart={this.onEditStartQuotes}
                               onEditStop={this.onEditStop}
        />);
      }
    }

    return (
      <div className={styles["sessions-line"]} ref="SessionsContainer">
        <div className={styles["sessions-divisions"]}
             onDoubleClick={this.props.editable && this.addSessionQuotes}>{divisions}</div>
        {handlers}
      </div>
    );
  }
});

export default SessionsDay;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/Day.jsx